import React from 'react';
import { AdminLayout } from '../components/admin/AdminLayout';
import { ConfigDashboard } from '../components/admin/ConfigDashboard';

export const AdminConfigPage: React.FC = () => {
  return (
    <AdminLayout 
      title="System Configuration"
      subtitle="Environment settings and service bindings"
    >
      <ConfigDashboard />
    </AdminLayout>
  );
};